import Bouncer from '../bouncer/dist/bouncer.js';

class UcForm {
    constructor(form) {
        this.form = form;
        this.formId = this.form.id;
        this.mode = this.form.getAttribute('data-uc-form-json');

        this.bouncerConfig = {
            messages: {
                missingValue: {
                    checkbox: 'Dette felt er påkrævet.',
                    radio: 'Vælg venligst en værdi.',
                    select: 'Vælg venligst en værdi.',
                    'select-multiple': 'Vælg venligst mindst én værdi.',
                    default: 'Udfyld venligst dette felt.'
                },
                patternMismatch: {
                    email: 'Indtast venligst en gyldig email-adresse.',
                    url: 'Indtast venligst en URL.',
                    number: 'Indtast venligst et tal',
                    color: 'Brug venligst følgende format: #rrggbb',
                    date: 'Brug venligst formatet ÅÅÅÅ-MM-DD',
                    time: 'Brug venligst 24-timers format. F.eks. 23:00',
                    month: 'Brug venligst formatet ÅÅÅÅ-MM',
                    default: 'Indtast venligst i det ønskede format.'
                },
                outOfRange: {
                    over: 'Vælg venligst en værdi der ikke er større end {max}.',
                    under: 'Vælg venligst en værdi der ikke er mindre end {min}.'
                },
                wrongLength: {
                    over: 'Kort venligst denne tekst ned til maksimalt {maxLength} tegn. Du bruger i øjeblikket {length} tegn.',
                    under: 'Forlæng venligst denne tekst til {minLength} tegn eller mere. Du bruger i øjeblikket {length} tegn.'
                }
            },
            // Custom Events
            emitEvents: true // If true, emits custom events
        }

        if (this.mode == "ajax") {
            // If true, native form submission is suppressed even when form validates
            this.bouncerConfig.disableSubmit = true;
        }

        this.bouncer = new Bouncer('#' + this.formId, this.bouncerConfig);

        console.log('form', this);

        this.form.addEventListener('bouncerFormValid', function (event) {
            this.submitForm();
        }.bind(this));

        //console.log(this);
    }

    async submitForm() {
        //console.log('submitForm this', this);

        var result = await fetch(this.form.action, {
            body: new FormData(this.form),
            method: "post",
        });

        if (result.status == 200) {
            this.form.classList.add('uc-form--submitted');
            this.form.querySelectorAll('.uc-field__control, .uc-submit').forEach(elm => {
                elm.setAttribute('disabled', 'disabled');
            });
        }
        else {
            console.log(result);
        }
    }
}




window.addEventListener('DOMContentLoaded', (e) => {
    document.querySelectorAll('[data-uc-form-json]').forEach(form => {
        new UcForm(form);
    });
});